import { useState } from "react";
import { FaSync } from "react-icons/fa";
import Sidebar from "../Sidebar/Sidebar";
import "./UpdateInventoryCSV.css";

const UpdateInventoryCSV = () => {
  const [file, setFile] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState("");
  const [errorDetails, setErrorDetails] = useState([]);

  // ✅ Fixed token key
  const token = localStorage.getItem("access_token");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
    setErrorDetails([]);
  };

  const handleUpdate = async () => {
    if (!file) {
      setMessage("Please select a CSV file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUpdating(true);
      const response = await fetch(
        "http://127.0.0.1:8000/pharmacies/update-inventory-csv",
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Update failed.");
      }

      const result = await response.json();
      setMessage(
        `✅ Updated: ${result.updated}, Skipped: ${result["skipped (duplicates)"]}, Errors: ${result.errors.length}`
      );

      // If there are error messages, store them separately
      if (result.errors && result.errors.length > 0) {
        setErrorDetails(result.errors);
      }
    } catch (err) {
      setMessage(`❌ ${err.message}`);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <h1 className="title">🔄 Update Inventory CSV</h1>

        {message && <p className="upload-message">{message}</p>}

        {errorDetails.length > 0 && (
          <div className="error-list">
            <h4>Details:</h4>
            <ul>
              {errorDetails.map((err, index) => (
                <li key={index}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="upload-section">
          <input type="file" accept=".csv" onChange={handleFileChange} />
          <button onClick={handleUpdate} disabled={updating}>
            <FaSync style={{ marginRight: "5px" }} />{" "}
            {updating ? "Updating..." : "Update CSV"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateInventoryCSV;
